export default {
  'common.operation': 'Operation',
  'common.add': 'Add ',
  'common.increase': 'Increase',
  'common.edit': 'Edit',
  'common.modify': 'Modify',
  'common.query': 'Search',
  'common.detail': 'View',
  'common.reset': 'Reset',
  'common.delete': 'Delete',
  'common.recover': 'Recover',
  'common.deleteConfirm': 'Are you sure to delete?',
  'common.recoverConfirm': '确定恢复吗？',
  'common.selectPlaceholder': '请选择',
  'common.inputPlaceholder': '请输入',
  'common.sure': 'OK',
  'common.cancel': 'Cancel',
  'common.saveAndNext': '保存并下一步',
  'common.prev': '上一步',
  'common.save': 'Save',
  'common.recovery': '恢复',
  'common.submit': 'Submit',
  'common.excel': 'Export',
  'common.agree': '同意',
  'common.reject': '拒绝',
  'common.placeHolder.beginTime': '请选择开始时间',
  'common.placeHolder.endTime': '请选择结束时间',
  'common.require.beginTime': '开始时间不为空',
  'common.require.endTime': '结束时间不为空',
  'common.validate.beginTime': '开始时间需小于结束时间',
  'common.validate.endTime': '结束时间需大于开始时间',
  'common.validate.noEmoji': 'Emojis are not allowed',
  'common.publish': '发布',
  'common.upload': 'Upload',
  'common.upload.image': 'Upload Picture',
  'common.upload.video': 'Upload Video',
  'common.batchDelete': '批量删除',
  'common.select': '选择',
  'common.selectVerify': '至少选择一条!',
  'common.tip': '提示',
  'common.sync': '同步',
  'common.currency': '币种',
  'common.currency.placeholder': '请选择币种',
  'common.y': '是',
  'common.n': '否',
  'common.setting': '设置',
  'common.prompted': 'System Prompt',
  'common.reRequest': 'Request Timeout, Reattempting...',
  'common.tryAgain': 'Request Timeout, Please try again later.',
  'common.select.user': 'Select user',
  'common.select.department': 'Department',
  'common.user.userAndRealName': 'User account/name',
  'common.user.account': 'Please enter your account',
  'common.user.username': 'User account',
  'common.user.realname': 'User name',
  'common.user.sex': 'Sex',
  'common.user.phone': 'Phone',
  'common.user.department': 'Department',
  'common.user.serach': 'Please enter a keyword search',

  'common.upload.format': 'Please upload the file in the specified format',
  'common.upload.filename': 'The file name is too long. Change the file name and upload it again',
  'common.upload.filesize': 'The file size cannot exceed',
  'common.upload.filenumber': 'Upload a maximum of {number} files',
  'common.upload.fileimage': 'images',
  'common.upload.filevideo': 'videos',
  'common.upload.imagelimit': 'Upload more than ',
  'common.upload.imagesuffix': ' pictures, please modify',
  'common.upload.videolimit': 'Upload more than ',
  'common.upload.videosuffix': ' videos, please modify',
  'common.validate.noEmoji': 'Cannot contain emojis',
  'common.office.formatDesc': 'File format is not supported',
  'common.office.loading': 'Loading...',
  'common.office.offlineDesc': 'Network unavailable. It will reload automatically when restored.',
  'common.column.min': 'At least one column must be retained',
  'common.formSetting.min': 'At least one filter item must be retained'
}
